//ASSETS
import placeholderBrandLogo from "../assets/placeholder-brandlogo.png";
import placeholderAsset from "../assets/placeholder-background-story.jpg";
import placeholderButtonLogo from "../assets/placeholder-buttonlogo.png";
//TYPES
import { ContextState, Slide, Element } from "../types/contextType";

export function create_creative_clone(creative: ContextState): ContextState {
  //
  // clone creative object and update missing text / assets with placeholder data (AF 13-07-23)
  //
  let creativeClone = JSON.parse(JSON.stringify(creative));
  if (!creativeClone.metadata.brandLogo.bodyCropped) creativeClone.metadata.brandLogo.bodyCropped = placeholderBrandLogo;
  if (!creativeClone.metadata.button.logo.bodyCropped) creativeClone.metadata.button.logo.bodyCropped = placeholderButtonLogo;
  if (!creativeClone.metadata.brandName) creativeClone.metadata.brandName = "Brand Name";
  if (!creativeClone.metadata.content) creativeClone.metadata.content = "Format content goes here";
  creativeClone.metadata.slides.map((slide: Slide, i: number) => {
    if (creativeClone.metadata.format === "clips" && !slide.media.poster) slide.media.poster = placeholderAsset;
    /**
     * HTL 06-09-23
     * Add the placeholder image if user hasn't uploaded media, and the frame isn't a split frame.
     */
    if (!slide.media.bodyCropped && !slide.media.videoSplitFrame) {
      slide.media.bodyCropped = placeholderAsset;
      slide.media.mimeType = "image/jpg";
    }
    /**
     * HTL 06-09-23
     * Add default content if user hasn't added any.
     */
    if (creativeClone.metadata.format !== "swipe" && !slide.content) slide.content = `Frame ${i + 1} of ${creativeClone.metadata.format}`;
    /**
     * HTL 06-09-23
     * Remove any bodyCropped if the slide is a split frame.
     */
    if (slide.media.videoSplitFrame) {
      slide.media.bodyCropped = "";
    }
    slide.elements.map((element: Element) => {
      if (!element.bodyOriginal) {
        element.mimeType = "image/jpg";
        element.bodyOriginal = placeholderAsset;
      }
    });
  });
  return creativeClone;
}
